{
  "name": "yabi",
  "version": "1.16.0",
  "scripts": {
    "ng": "ng",
    "postinstall": "node scripts/merge-i18n.js",
    "i18n": "node scripts/validate-i18n.js && node scripts/merge-i18n.js",
    "i18n:check": "node scripts/validate-i18n.js",
    "i18n:merge": "node scripts/merge-i18n.js",
    "lint:fonts": "node scripts/validate-font-weights.js",
    "lint:scss": "node scripts/scss-budget-gate.js",
    "lint:scss:update": "node scripts/scss-budget-gate.js --update",
    "font:sync": "node scripts/sync-font-link.js",
    "prebuild": "node scripts/sync-font-link.js && node scripts/validate-font-weights.js && node scripts/scss-budget-gate.js && node scripts/validate-i18n.js && node scripts/merge-i18n.js",
    "prestart": "node scripts/sync-font-link.js && node scripts/merge-i18n.js",
    "build": "ng build",
    "build:fast": "ng build --configuration=development",
    "build:analyze": "ng build --stats-json && npx webpack-bundle-analyzer dist/yabi/stats.json",
    "start": "ng serve",
    "start:fast": "ng serve --configuration=development --hmr",
    "start:turbo": "ng serve --configuration=development --hmr --disable-host-check --live-reload=false",
    "start:lightning": "cross-env NODE_OPTIONS=\"--max-old-space-size=8192\" ng serve --configuration=development --hmr --disable-host-check --live-reload=false",
    "local": "ng serve --configuration=local",
    "develop": "ng serve -o --host 0.0.0.0 --port 8083 --configuration=develop",
    "stage": "ng serve -o --configuration=stage",
    "qa": "ng serve -o --configuration=qa",
    "prod": "ng serve -o --configuration=prod",
    "watch": "ng build --watch --configuration development",
    "test": "jest",
    "test:watch": "jest --watch",
    "test:ci": "jest --config=jest.ci.config.json --watchAll=false --ci --verbose",
    "cypress:open": "npx cypress open",
    "lint": "ng lint"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.10",
    "@angular/cdk": "^21.2.8",
    "@angular/common": "^21.2.10",
    "@angular/compiler": "^21.2.10",
    "@angular/core": "^21.2.10",
    "@angular/forms": "^21.2.10",
    "@angular/google-maps": "^21.2.8",
    "@angular/platform-browser": "^21.2.10",
    "@angular/platform-browser-dynamic": "^21.2.10",
    "@angular/router": "^21.2.10",
    "@angular/service-worker": "^21.2.10",
    "@apollo/client": "^4.1.8",
    "@googlemaps/js-api-loader": "^2.0.2",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "@primeuix/themes": "^2.0.3",
    "apollo-angular": "^13.0.0",
    "awesome-phonenumber": "^7.8.0",
    "chart.js": "^4.5.1",
    "exceljs": "^4.4.0",
    "file-saver-es": "^2.0.5",
    "graphql": "^16.13.2",
    "lodash-es": "^4.18.1",
    "ngx-device-detector": "^11.0.0",
    "ngx-drag-scroll": "^21.0.0",
    "ngx-spinner": "^21.1.0",
    "ngx-toastr": "^20.0.5",
    "postcss-rtl": "^2.0.0",
    "primeicons": "^7.0.0",
    "primeng": "^21.1.6",
    "rxjs": "^7.8.2",
    "sass": "^1.99.0",
    "zone.js": "^0.16.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^21.2.8",
    "@angular/cli": "^21.2.8",
    "@angular/compiler-cli": "^21.2.10",
    "@angular/localize": "^21.2.10",
    "@eslint/js": "^10.0.1",
    "@types/file-saver-es": "^2.0.3",
    "@types/google.maps": "^3.64.0",
    "@types/jasmine": "^6.0.0",
    "@types/jest": "^30.0.0",
    "@types/lodash-es": "^4.17.12",
    "angular-eslint": "21.4.0",
    "cross-env": "^10.1.0",
    "cypress": "15.14.1",
    "eslint": "^10.3.0",
    "jest": "^30.3.0",
    "jest-environment-jsdom": "^30.3.0",
    "jest-preset-angular": "^16.1.4",
    "ts-jest": "^29.4.9",
    "typescript": "~6.0.3",
    "typescript-eslint": "8.59.2"
  }
}
